export function pxToRem(pixels: number) {
  return pixels / 10 + 'rem';
}
